module.exports = __webpack_public_path__ + "bbf79eb7e0c2cef85e82d7acc2116fc1.pdf";